import React, { MouseEventHandler } from "react";
import { Button } from "@mui/material";
import { ArrowRight } from "lucide-react";
import useIsMobile from "components/hooks/useIsMobile";

export const NextStepButton: React.FC<{
  skippable?: boolean;
  hasValue?: boolean;
  disabled?: boolean;
  continueClick?: MouseEventHandler<HTMLButtonElement>;
  buttonText?: string;
  minWidth?: string | number;
  forcePrimary?: boolean;
  fullWidth?: boolean;
}> = ({
  skippable = false,
  hasValue,
  disabled,
  continueClick,
  buttonText,
  minWidth,
  forcePrimary = false,
  fullWidth = false,
}) => {
  const isMobile = useIsMobile();
  const skipButton = !forcePrimary && !hasValue && skippable;

  return (
    <Button
      variant={!skipButton ? "contained" : "text"}
      color="primary"
      disabled={disabled || (!hasValue && !skippable)}
      onClick={continueClick}
      endIcon={fullWidth && !skipButton ? <ArrowRight /> : undefined}
      sx={{
        width: fullWidth ? "100%" : "auto",
        minWidth: skipButton ? "unset" : minWidth ?? "180px",
        bgcolor: !skipButton ? "#198282" : "transparent",
        color: !skipButton ? "white" : "#198282",
        "&:hover": {
          bgcolor: !skipButton ? "#276767" : "transparent",
        },
        "&.Mui-disabled": {
          backgroundColor: skipButton ? "transparent" : "#EAEBEC",
          color: skipButton ? "#9CA3AF" : undefined,
        },
        borderRadius: "32px",
        fontSize: skipButton
          ? "1rem"
          : fullWidth && isMobile
            ? "0.95rem"
            : "1.15rem",
        lineHeight: 1.4,
        px: skipButton ? 1 : fullWidth && isMobile ? 2 : 4,
        py: skipButton ? 1 : undefined,
        textTransform: "none",
        boxShadow: isMobile ? "0px -1px 20px 5px rgba(255, 255, 255, .2)" : "",
      }}
    >
      {buttonText || (!skipButton || hasValue ? "Continue" : "Skip")}
    </Button>
  );
};
